import { render } from "./resourcePool.vue?vue&type=template&id=2cf3bb10&scoped=true&ts=true"
import script from "./resourcePool.vue?vue&type=script&lang=ts"
export * from "./resourcePool.vue?vue&type=script&lang=ts"

import "./resourcePool.vue?vue&type=style&index=0&id=2cf3bb10&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf3bb10"]])

export default __exports__